import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes
} from '@angular/core';

@Component({
  selector: 'cs-alert',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('flyInOut', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        animate(300, keyframes([
          style({ opacity: 0, transform: 'translateX(-100%)', offset: 0 }),
          style({ opacity: 1, transform: 'translateX(15px)', offset: 0.3 }),
          style({ opacity: 1, transform: 'translateX(0)', offset: 1.0 })
        ]))
      ]),
      transition('* => void', [
        animate(300, keyframes([
          style({ opacity: 1, transform: 'translateX(0)', offset: 0 }),
          style({ opacity: 1, transform: 'translateX(-15px)', offset: 0.7 }),
          style({ opacity: 0, transform: 'translateX(100%)', offset: 1.0 })
        ]))
      ])
    ])
  ],
  template: `    
    <div class="cs-alert-wrapper">
      <div
        class="cs-alert cs-alert-{{alert.type}}"
        [@flyInOut]="'in'"
        *ngFor="let alert of inputs.alerts">
        <p>
          {{ alert.body }}
        </p>
        <button 
          class="ion-close-round"
          (click)="close.emit(alert.id)"
          *ngIf="!alert.preventClose">
        </button>
      </div>
    </div>
  `
})

export class CsAlertComponent {
  // NODE: type == warning or danger
  @Input() inputs: any = {};
  @Output() close = new EventEmitter<Object>();

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-alert/cs-alert.component.ts